import {Component, OnInit} from '@angular/core';
import {TokenInterface} from "@app/Interfaces/token.interface";
import {jwtDecode} from "jwt-decode";
import {ErrorModule} from "@app/error/error.module";
import {FilterModule} from "@app/filter/filter.module";
import {GroupByPipe} from "@app/quarantine/shared/pipes/group-by/group-by.pipe";
import {MedIconResetModule} from "@mk/med-icons";
import {MedPaginationModule} from "@med-ui/med-pagination/med-pagination.module";
import {NgForOf, NgIf} from "@angular/common";
import {QuarantineTableComponent} from "@app/quarantine/quarantine-table/quarantine-table.component";
import {ActivatedRoute, RouterModule} from "@angular/router";
import {routes} from "@app/quarantine/quarantine/quarantine.routes";
import {DataService} from "@app/shared/data.service";


@Component({
  selector: 'app-quarantine',
  templateUrl: './quarantine.component.html',
  styleUrls: ['./quarantine.component.scss'],
  standalone: true,
  imports: [
    ErrorModule,
    FilterModule,
    GroupByPipe,
    MedIconResetModule,
    MedPaginationModule,
    NgForOf,
    NgIf,
    QuarantineTableComponent,
  ]
})
export class QuarantineComponent implements OnInit{
  token: TokenInterface = jwtDecode(localStorage['access_token']);
  
  constructor(
      private activatedRoute: ActivatedRoute,
      private dataService: DataService
  ) {}
  
  ngOnInit() {
    this.dataService.breadcrumbsArray.next(this.activatedRoute.snapshot.data['breadcrumbs'])
  }
  
  isPageAvailable = this.token.realm_access.roles.includes('accounting-register-viewer-role') &&
      (this.token.realm_access.roles.includes('moz-member-role') ||
          this.token.realm_access.roles.includes('doz-member-role') ||
          this.token.realm_access.roles.includes('zoz-member-role'))
}
